/**
 * Transform array of artlas results
 * in an {x, y} objects of chart data
 */
export const getChartDataFromResult = function (results) {
  let x = []
  let y = []
  let dates = []
  results.forEach(currentResult => {
    const date = (
      currentResult && currentResult.begin_date ||
      currentResult && currentResult.year_b ||
      currentResult && currentResult.year_c1 ||
      currentResult && currentResult.begin_year ||
      currentResult && currentResult.year && currentResult.year + '-01-01')
    !!date && dates.push(new Date(date).getFullYear())
  })
  dates = dates.sort()
  let prev
  for (var i = 0; i < dates.length; i++) {
    if (dates[i] !== prev) {
      x.push(dates[i])
      y.push(1)
    } else {
      y[y.length - 1]++
    }
    prev = dates[i]
  }
  return { x, y }
}

export const getChartXaxisRange = function (x) {
  const minxvalue = 10
  const min = Math.min.apply(Math, x)
  const max = Math.max.apply(Math, x)
  const minRange = 100
  const spaceBetween = 5
  const count = max - min

  if (count < minRange && x.length < minxvalue) {
    const margin = (minRange - count) / 2
    return [
      min - margin,
      max + margin
    ]
  }

  return [
    min - spaceBetween,
    max + spaceBetween
  ]
}

export const getChartYaxisRange = function (y) {
  const minyvalue = 5
  y.push(minyvalue)
  const min = 0
  const max = Math.max.apply(Math, y)

  return [min, max]
}

export const getCatalogs = function (sections) {
  let catalogs = []

  sections.map(section => {
    let catalogIndex = -1
    catalogs.map((catalog, i) => {
      if (catalog.id_exhibition_catalog === section.id_exhibition_catalog) {
        catalogIndex = i
        return catalogIndex
      }
    })

    if (catalogIndex === -1) {
      catalogs.push({
        id_exhibition_catalog: section.id_exhibition_catalog,
        title: section.exhibition_catalog_title,
        space: section.space,
        source_catalog: section.source_catalog,
        source: section.source,
        city: section.city,
        begin_date: section.begin_date,
        end_date: section.end_date,
        contributor: section.contributor,
        publishing_year: section.publishing_year,
        sections: [section],
        begin_day: section.begin_day,
        begin_month: section.begin_month,
        begin_year: section.begin_year,
        end_day: section.end_day,
        end_month: section.end_month,
        end_year: section.end_year
      })
    } else {
      catalogs[catalogIndex].sections.push(section)
    }
  })
  return catalogs
}

export const getSections = function (exhibitedWorks) {
  let sections = []
  let count = 0
  exhibitedWorks.map(exhibitedWork => {
    count++
    let sectionIndex = -1
    sections.map((section, i) => {
      if (section.id_exhibition_section === exhibitedWork.id_exhibition_section) {
        sectionIndex = i
        return sectionIndex
      }
    })
    if (sectionIndex === -1) {
      sections.push({
        id_exhibition_section: exhibitedWork.id_exhibition_section,
        section_title: exhibitedWork.section_title,
        space: exhibitedWork.space,
        section_address: exhibitedWork.section_address,
        contributor: exhibitedWork.contributor,
        exhibitedWorks: [exhibitedWork]
      })
    } else {
      sections[sectionIndex].exhibitedWorks.push(exhibitedWork)
    }
  })

  return { sections, count }
}



// WEBPACK FOOTER //
// ./src/services/data.js